// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/index.tsx
// Version: v1.0.1
// Description: React App Entry Point
import React from "react";
import ReactDOM from "react-dom/client";
import Main from "./App.tsx";
import "./Index.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error('ERROR: Root element with ID "root" not found in index.html!');
  throw new Error("Root element not found");
}

console.log("Attempting to render React app...");

try {
  ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
  );
  console.log("React render call successfully initiated.");
} catch (error) {
  console.error("ERROR during React rendering:", error);
}
